import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import Typography from 'apollo-react/components/Typography';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { exportPowerBIReports } from '../../actions/PowerBIActions';
import { EXPORT_TYPES } from '../../constants/PowerBIConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  modal: {
    minWidth: 450,
    zIndex: 1200,
  },
  label: {
    marginBottom: 5,
  },
});

const ExportReportModal = ({ onClose, selectedReports, setSelectedReports }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const dispatch = useDispatch();

  const [exportType, seExportType] = useState(EXPORT_TYPES[0].value);

  const handleReportExport = async () => {
    dispatch(exportPowerBIReports(selectedReports, exportType));

    setSelectedReports([]);
    onClose();
  };

  const buttonProps = [
    {
      label: translateString('Cancel'),
    },
    {
      label: translateString('Export'),
      onClick: handleReportExport,
    },
  ];

  return (
    <Modal
      onClose={onClose}
      open
      className={classes.modal}
      title={translateString('Export Reports')}
      buttonProps={buttonProps}
    >
      <Typography className={classes.label}>
        {translateString('Select a type of file to export')}
      </Typography>
      <RadioGroup value={exportType} onChange={(e) => seExportType(e.target.value)} row>
        {EXPORT_TYPES.map((item) => (
          <Radio key={item.label} value={item.value} label={item.label} />
        ))}
      </RadioGroup>
    </Modal>
  );
};

export default ExportReportModal;
